/* ==========================================================================
Site customisations
========================================================================== */

var toastMaintenanceShown = false;

function csrf_token_init() {
  // Set CSRF token for jQuery requests
  $.ajaxSetup({
    headers: {
      'X-CSRFToken': $.cookie('csrftoken'),
    }
  });
}

//Bulma tags
function initBulmaTags() {
  if ($(".bulma-tags").length) {
    bulmaTagsinput.attach();
  }
}

//Navigation tabs
function initNavigationTabs() {
  $(document).on('click', '.navigation-tabs .tabs ul li', function () {
    var tab_id = $(this).attr("data-tab");

    $(this).siblings("li").removeClass("is-active");
    $(this)
      .closest(".navigation-tabs")
      .children(".navtab-content")
      .removeClass("is-active");
    //$('.navtab-content').removeClass('is-active');

    $(this).addClass("is-active");
    $("#" + tab_id).addClass("is-active");

    // Check if a DataTable exists in the activated tab and redraw it
    $("#" + tab_id).find("table.datatable").each(function () {
      if ($.fn.DataTable.isDataTable(this)) {
        $(this).DataTable().columns.adjust().draw(false);
      }
    });
  });
}

function tab_by_hash_init() {
  // Open tab by url hash
  var hash = window.location.hash;
  if (hash) {
    var tabId = 'tab-' + hash.slice(1);
    var tabElement = $('.navigation-tabs li[data-tab="' + tabId + '"]');
    if (tabElement.length > 0) {
      let navigation_tabs = tabElement.closest('.navigation-tabs');
      navigation_tabs.find(' > .tabs li').removeClass('is-active');
      navigation_tabs.find(' > .navtab-content').removeClass('is-active');
      navigation_tabs.find(' > #' + tabId).addClass('is-active');
      tabElement.addClass('is-active');
    }
  }
}

// Chosen JS
function init_chosen_multiple() {
  if ($('.chosen-multiple select').length) {
    $('.chosen-multiple select').chosen({
      disable_search_threshold: 10,
      width: '100%',
    });
  }
}

function chosen_update(elem) {
  elem.trigger('chosen:updated');
}

function chosen_select_all(elem, update = true) {
  elem.find('option').prop('selected', true).prop('disabled', false);
  if (update) {
    chosen_update(elem);
  }
}

function chosen_unselect_all(elem, update = true) {
  elem.find('option').prop('selected', false).prop('disabled', false);
  if (update) {
    chosen_update(elem);
  }
}

// Modal close logic copied from modal-async.js
function modal_close(modalID) {
  $("#" + modalID + " .modal-background").toggleClass("scaleInCircle");
  $("#" + modalID + " .modal-content").toggleClass("scaleIn");
  $("#" + modalID + " .modal-close").toggleClass("is-hidden");
  //Restore native body scroll
  if ($(".dashboard-wrapper").length) {
    $("body").removeClass("is-fixed");
  }
  setTimeout(function () {
    $(".modal.is-active").removeClass("is-active");
    //Restore sticky nav and backktotop
    $("#scrollnav, #backtotop").toggleClass("is-hidden");
  }, 500);
}

// Lazy load inside HTMX loaded element
document.body.addEventListener('htmx:load', function (evt) {
  const el = evt.detail.elt.querySelectorAll('[data-lazy-load]');
  const observer = lozad(el, {
    loaded: function (el) {
      el.parentNode.classList.add('loaded');
    }
  });
  observer.observe();
});

function amount_display(amount) {
  return Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
}

function box_collapsed_init() {
  var has_elem = false;
  var height = null;
  var max_height = null;
  $('.box-collapsed').each(function () {
    height = $(this).height();
    max_height = $(this).data('max-height');

    if (!max_height) {
      max_height = 400;
      $(this).data('max-height', max_height);
    }

    if (height >= max_height) {
      has_elem = true;
      $(this).find('.box-container').css({ 'maxHeight': max_height + 'px' });
      $(this).append('<div class="box-fade"></div><div class="box-toggle">Show more</div>');
    }
  });

  if (has_elem) {
    $(document).on('click', '.box-toggle', function () {
      if ($(this).parent().hasClass('is-active')) {
        $(this).text('Show more');
        $(this).parent().find('.box-container').css({ 'maxHeight': max_height + 'px' });
        $(this).parent().removeClass('is-active');
      } else {
        max_height = $(this).parent().data('max-height');
        $(this).text('Show less');
        $(this).parent().find('.box-container').css({ 'maxHeight': 'unset' });
        $(this).parent().addClass('is-active');
      }
    });
  }
}

function custom_pages_js_init() {
  // Modal trigger CTA when it needs to select from sign up product dropdown
  $(document).on('click', '.modal-trigger.target-product', function () {
    let data_target = $(this).attr('data-target');
    if (data_target) {
      let data_modal = $(this).attr('data-modal');
      $('#' + data_modal + ' #id_product').val(data_target);
    }
  });

  $(document).on('click', '.button-toggle-wrapper .block-header', function () {
    $(this).toggleClass('is-active');
    $(this).closest('.button-toggle-wrapper').find('.block-body').slideToggle('fast');
  });

  $(document).on('submit', 'form.loading-on-submit', function (e) {
    if (this.checkValidity()) {
      $('form.loading-on-submit button[type="submit"]').addClass('is-loading');
    }
  });

  if ($('#articles-case-studies').length) {
    // Articles case studies random order and featured
    var cards = $('.blog-section .column');
    for (var i = 0; i < cards.length; i++) {
      var target1 = Math.floor(Math.random() * cards.length - 1) + 1;
      var target2 = Math.floor(Math.random() * cards.length - 1) + 1;
      cards.eq(target1).before(cards.eq(target2));
    }
    $('.blog-section .column:nth-of-type(1)').addClass('featured-post');
  } else if ($('#contact-us-content').length) {
    // Contact us page
    $(document).on("click", ".tabbed-links li", function () {
      var target = $(this).attr("data-contact");
      $(".contact-block").addClass("is-hidden");
      $("#" + target).removeClass("is-hidden");
      $(".tabbed-links li.is-active").removeClass("is-active");
      $(this).addClass("is-active");
    });
  } else if ($('#invoice').length) {
    // Invoice
    if ($('.invoice-form').length) {
      $(document).on('click', '.pg-button-primary', function () {
        $(this).addClass('is-loading');
      });
      $(document).on('click', '.toggle-invoice-send', function () {
        if ($('.invoice-send').css('display') == 'none') {
          $('.invoice-send').slideDown();
        } else {
          $('.invoice-send').slideUp();
        }
      });
      autosize($('#id_email_message'));
    }
  } else if ($('#invoice-create').length) {
    // Create invoice
    $(document).on('change', '.quantity input, .price select', function () {
      let item_id = $(this).attr('id');
      let item_num = item_id.split('_').pop();
      let quantity = $('.quantity input#id_quantity_' + item_num).val();
      let price_raw = $('.price select#id_price_' + item_num).find(":selected").text();
      let price = price_raw.replace(/\D/g, '');
      let amount = (quantity * price) / 100;
      $('#total_' + item_num + ' .has-price').text(amount_display(amount));
    });
  }
}

function chosen_multiple_select_init() {
  if ($('.chosen-multiple select').length) {
    $('.chosen-multiple select').chosen({
      disable_search_threshold: 10,
      width: '100%',
    });

    $('.chosen-multiple-select-all').click(function () {
      chosen_select_all(
        $(this).parent().parent().find('select')
      );
    });

    $('.chosen-multiple-unselect-all').click(function () {
      chosen_unselect_all(
        $(this).parent().parent().find('select')
      );
    });
  }
}

function htmx_config(form) {
  // Set CSRF token for HTMX requests
  htmx.on('htmx:beforeSend', function (event) {
    var xhr = event.detail.xhr;
    xhr.setRequestHeader('X-CSRFToken', $.cookie('csrftoken'));
  });

  // On HTMX response error show toast message
  document.body.addEventListener('htmx:responseError', function (e) {
    if (toastMaintenanceShown == false) {
      toastMaintenanceShown = true;

      let title = e.detail.xhr.status.toString();
      let message = e.detail.xhr.statusText;
      let class_ = 'danger-toast';
      let icon = 'icon-close';
      let backgroundColor = '#FF7273';

      if (e.detail.xhr.status == 503) { // Service Unavailable
        title = "We're down for maintenance";
        message = 'Website is undergoing maintenance and will be back soon.';
        class_ = 'info-toast';
        icon = 'icon-info';
        backgroundColor = '#039BE5';
      }

      iziToast.show({
        class: class_,
        icon: icon,
        title: title,
        message: message,
        backgroundColor: backgroundColor,
        progressBarColor: backgroundColor,
        titleColor: '#fff',
        messageColor: '#fff',
        iconColor: '#fff',
        position: 'topRight',
        transitionIn: 'fadeInDown',
        timeout: false,
        zindex: 99999,
      });
    }
  });
}

$(function() {
  csrf_token_init();
  async_init();
  htmx_config();
  chosen_multiple_select_init();
  tab_by_hash_init();
  box_collapsed_init();
  custom_pages_js_init();
});
